import BaseAbility from 'umg-ember-backend/abilities/base';

export default class ProductElementAbility extends BaseAbility {}
